module.exports = __webpack_public_path__ + "media/images/www/company/real-estate-sign-rent-e05a464ead9023d938c5fceca5558d20.svg";